import { ModelSagres } from "../../model-sagres";
import { SelectValue } from "../../select-value";

export class TabelasAuxiliaresCargo extends ModelSagres {
  tipoVinculo: SelectValue[];
  tipoRegimeJuridico: SelectValue[];
  tipoRegimePrevidenciario: SelectValue[];
  tipoNatureza: { Id: number; Descricao: string }[];
  tipoEscolaridade: SelectValue[];
  tipoSituacao: SelectValue[];
  tipoAtoNormativo: SelectValue[];
  tipoAlteracaoNormativa: SelectValue[];
  tipoVeiculoPublicacaoNormativo: SelectValue[];
  nomenclaturas: { IdVinculo: number; Descricao: string }[];

  constructor(obj?: any) {
    super();
    this.tipoVinculo = obj?.tipoVinculo ?? [];
    this.tipoRegimeJuridico = obj?.tipoRegimeJuridico ?? [];
    this.tipoRegimePrevidenciario = obj?.tipoRegimePrevidenciario ?? [];
    this.tipoNatureza = obj?.tipoNatureza ?? [];
    this.tipoEscolaridade = obj?.tipoEscolaridade ?? [];
    this.tipoSituacao = obj?.tipoSituacao ?? [];
    this.tipoAtoNormativo = obj?.tipoAtoNormativo ?? [];
    this.tipoAlteracaoNormativa = obj?.tipoAlteracaoNormativa ?? [];
    this.tipoVeiculoPublicacaoNormativo = obj?.tipoVeiculoPublicacaoNormativo ?? [];
    this.nomenclaturas = obj?.nomenclaturas ?? [];
  }
}
